import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InventoryContext } from '../../inventory-manager/inventory.context';
import { HttpResponse } from '@angular/common/http';
import { PopupService } from '../../shared/modal/popup.service';
import { AlertService } from '../../shared/alert/alert.service';
import { JhiEventManager, JhiLanguageService } from '../../shared/core-utils';
import { TransactionService } from '../../shared/inventory/service/transaction.service';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

const SUCCESS_CONFIRMED = 'inventoryManagerApp.lot.withdrawal.inventory.success.confirmed.transaction';
const SUCCESS_PENDING = 'inventoryManagerApp.lot.withdrawal.inventory.success.pending.transaction';

@Component({
    selector: 'jhi-lot-withdrawal-dialog',
    templateUrl: './lot-withdrawal-dialog.component.html'
})
export class LotWithdrawalDialogComponent implements OnInit, OnDestroy {
    searchResultDbId: string;
    totalSelectedLots: number;
    lotWithdrawals: any[];
    notes: any;
    confirmTransactions;
    subscriptionsManager = new SubscriptionsManager();

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private inventoryContext: InventoryContext,
        private alertService: AlertService,
        private activatedRoute: ActivatedRoute,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private transactionService: TransactionService
    ) {
        this.subscriptionsManager.add = this.activatedRoute.queryParams.subscribe((params) => {
            this.searchResultDbId = params.searchResultDbId;
        });

        this.lotWithdrawals = [];
        this.totalSelectedLots = 0;
        this.confirmTransactions = { selected: false };

        this.lotWithdrawals = Object.keys(this.inventoryContext.lotsCountByUnitName).map(
            (unit) =>
                this.buildLotWithdrawal(unit, this.inventoryContext.lotsCountByUnitName[unit])
        );

        this.totalSelectedLots = this.lotWithdrawals.map((lotWithdrawal) => lotWithdrawal.count).reduce((a, b) => a + b, 0);
    }

    private buildLotWithdrawal(unitName: string, lotSelected: number) {
        return {
            allAvailableSeed: { selected: false },
            amount: '',
            unit: unitName,
            count: lotSelected
        };
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    ngOnInit(): void {
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        const lotWithdrawalInput = {
            selectedLots: { searchRequest: null, itemIds: null },
            notes: this.notes,
            withdrawalsPerUnit: this.lotWithdrawals.reduce((map, obj) => {
                map[obj.unit] = {
                    reserveAllAvailableBalance: obj.allAvailableSeed.selected,
                    withdrawalAmount: obj.allAvailableSeed.selected ? 0 : obj.amount
                };
                return map;
            }, {})
        };

        if (this.searchResultDbId) {
            lotWithdrawalInput.selectedLots.searchRequest = this.searchResultDbId;
        } else {
            lotWithdrawalInput.selectedLots.itemIds = this.inventoryContext.itemIds;
        }

        if (this.confirmTransactions.selected) {
            this.subscriptionsManager.add = this.transactionService.createConfirmedWithdrawals(lotWithdrawalInput)
                .subscribe(
                    (res: HttpResponse<any>) =>
                        this.onSaveSuccess(SUCCESS_CONFIRMED));
        } else {
            this.subscriptionsManager.add = this.transactionService.createPendingWithdrawals(lotWithdrawalInput)
                .subscribe(
                    (res: HttpResponse<any>) =>
                        this.onSaveSuccess(SUCCESS_PENDING));
        }
    }

    private onSaveSuccess(message: any) {
        this.alertService.success(message);
        this.eventManager.broadcast({ name: 'columnFiltersChanged', content: 'OK' });
        this.activeModal.dismiss('saved');
    }

    cleanInputAmount(lotWithdrawal: any) {
        lotWithdrawal.amount = '';
    }
}

@Component({
    selector: 'jhi-lot-create-popup',
    template: ''
})
export class LotWithdrawalPopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(private route: ActivatedRoute,
                private popupService: PopupService
    ) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.popupService
                .open(LotWithdrawalDialogComponent as Component);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }

}
